import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core';
import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
const MINIMUM_SCORE = 3;
zxcvbnOptions.setOptions({
    graphs: zxcvbnCommonPackage.adjacencyGraphs,
    dictionary: _object_spread({}, zxcvbnCommonPackage.dictionary, zxcvbnEnPackage.dictionary)
});
export function validatePasswordStrength(password, userInputs) {
    return zxcvbn(password, userInputs).score >= MINIMUM_SCORE;
}
